var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-page',[_c('h1',[_vm._v("hello world")])])}
var staticRenderFns = []

export { render, staticRenderFns }